module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_TottenhamHotspur.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_TottenhamHotspur.png
// module id = 2196
// module chunks = 4